export default __webpack_public_path__ + "static/media/add-image.630ef075.svg";